import React from 'react';
import SalesAnalytics from '../components/Analytics/SalesAnalytics';

const Analytics: React.FC = () => {
  return <SalesAnalytics />;
};

export default Analytics;